import * as api from './admin.api';
import * as queries from './admin.queries';
import * as mutations from './admin.mutations';

export * from './admin.api';
export * from './admin.queries';
export * from './admin.mutations';

export default { ...api, ...queries, ...mutations };
